import React from 'react';
import ReactECharts from 'echarts-for-react';
import { format, addMonths, startOfMonth, endOfMonth, isWithinInterval, parseISO } from 'date-fns';

const LeaseRiskChart = ({ properties, leases }) => {
  const months = Array.from({ length: 6 }, (_, i) => addMonths(new Date(), i));
  
  const data = months.map(m => {
    const mStart = startOfMonth(m);
    const mEnd = endOfMonth(m);
    
    const expiring = properties.filter(p => {
      const lease = leases.find(l => l.id === p.currentLeaseId);
      if (!lease?.endDate) return false;
      const end = parseISO(lease.endDate);
      return isWithinInterval(end, { start: mStart, end: mEnd });
    });

    const totalAtRisk = expiring.reduce((sum, p) => sum + (p.rentRate || 0), 0);
    
    return {
      month: format(m, 'MMM yy'),
      count: expiring.length,
      revenue: totalAtRisk
    };
  });

  const option = {
    tooltip: { 
      trigger: 'axis',
      formatter: (params) => {
        const item = data[params[0].dataIndex];
        return `${item.month}<br/>Expiring: ${item.count}<br/>Revenue at Risk: $${item.revenue.toLocaleString()}`;
      }
    },
    grid: { left: '3%', right: '4%', bottom: '3%', top: '15%', containLabel: true },
    xAxis: { 
      type: 'category', 
      data: data.map(d => d.month),
      axisLine: { show: false },
      axisTick: { show: false }
    },
    yAxis: [
      { type: 'value', name: 'Leases', splitLine: { lineStyle: { type: 'dashed' } } },
      { type: 'value', name: 'Revenue', axisLabel: { formatter: '${value}' }, splitLine: { show: false } }
    ],
    series: [
      {
        name: 'Expiring Leases',
        type: 'bar',
        data: data.map(d => d.count),
        itemStyle: { color: '#4F46E5', borderRadius: [4, 4, 0, 0] },
        barWidth: '30%'
      },
      {
        name: 'Revenue at Risk',
        type: 'line',
        yAxisIndex: 1,
        data: data.map(d => d.revenue),
        smooth: true,
        lineStyle: { width: 3, color: '#EF4444' },
        symbolSize: 8,
        itemStyle: { color: '#EF4444' }
      }
    ]
  };

  return (
    <div className="bg-white p-6 rounded-3xl border border-gray-100 shadow-sm">
      <h3 className="text-xs font-black text-gray-400 uppercase tracking-widest mb-6">6-Month Revenue Exposure</h3>
      <div className="h-[300px]">
        <ReactECharts option={option} style={{ height: '100%' }} />
      </div>
    </div>
  );
};

export default LeaseRiskChart;